import { useSession } from "@/utils/session.ctx";
import { useSplash } from "@/utils/useSplash";
import { Redirect, Tabs } from "expo-router";
import React, { useEffect } from "react";
import "../../global.css";
import { MobileTabs, makeMobileIconTabBar } from "@/screens/menu/mobile.tabbar";
import { QrCodeIcon, StoreIcon, UserIcon, Wallet } from "lucide-react-native";
import { useMobileBreakpoint } from "@/utils/useMobileBreakpoint";
import { ActionContextProvider } from "@/screens/common/action.context.provider";
import { InvitationModalHandler } from "@/screens/invitation/invitation.modal";
import { useQRBadgeState } from "@/utils/useQRBadgeState";

export default function AuthenticatedLayout() {
  const { isInitialized, isAuthenticated } = useSession();
  const { signalSplash } = useSplash();
  const breakpoint = useMobileBreakpoint();
  const hasQRBadge = useQRBadgeState();

  useEffect(() => {
    if (isInitialized) {
      signalSplash({ sessionLoaded: true });
    }
  }, [isInitialized]);

  if (!isInitialized) {
    return null;
  }

  // Only require authentication within the (app) group's layout as users
  // need to be able to access the (auth) group and sign in again.
  if (!isAuthenticated) {
    // On web, static rendering will stop here as the user is not authenticated
    // in the headless Node process that the pages are rendered in.
    return <Redirect href="/auth" />;
  }

  return (
    <ActionContextProvider>
      <MobileTabs>
        <Tabs.Screen name="index" redirect />
        <Tabs.Screen
          name="wallet"
          options={{
            tabBarLabel: "My wallet",
            tabBarIcon: makeMobileIconTabBar(Wallet),
          }}
        />
        <Tabs.Screen
          name="qrs"
          options={{
            tabBarLabel: breakpoint === "desktop" ? "My QR codes" : "My QR",
            tabBarIcon: makeMobileIconTabBar(QrCodeIcon),
            tabBarBadge: hasQRBadge ? "" : undefined,
          }}
        />
        <Tabs.Screen
          name="orgs"
          options={{
            tabBarLabel: "Business",
            tabBarIcon: makeMobileIconTabBar(StoreIcon),
          }}
        />
        <Tabs.Screen
          name="profile"
          options={{
            ...(breakpoint === "desktop" ? { href: null } : undefined),
            tabBarLabel: "Profile",
            tabBarIcon: makeMobileIconTabBar(UserIcon),
          }}
        />
        {/* Redirects */}
        <Tabs.Screen
          name="restaurants/index"
          options={{
            href: null,
          }}
        />
        <Tabs.Screen
          name="restaurants/[...catchAll]/index"
          options={{
            href: null,
          }}
        />
      </MobileTabs>
      <InvitationModalHandler />
    </ActionContextProvider>
  );
}
